import React, { useEffect, useState } from "react";
import {
  Container,
  Title,
  TextInput,
  Group,
  Table,
  Text,
  Badge,
  Stack,
  Button,
} from "@mantine/core";
import { IconSearch, IconPlugOff } from "@tabler/icons-react";
import AddIntegrationModal from "../../components/AddIntegrationModal";
import integrationService from "../../services/integration.service";
import { IntegrationResponse } from "types/responses.type";
import dayjs from "dayjs";
import IntegrationCard from "components/IntegrationCard";

const Integration = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [connectedIntegrations, setConnectedIntegrations] = useState<
    IntegrationResponse[]
  >([]);
  const [search, setSearch] = useState("");

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const reloadConnectedIntegrations = () => {
    integrationService
      .getConnected()
      .then((integrations) => {
        setConnectedIntegrations(integrations ?? []);
      })
      .catch();
  };

  useEffect(() => {
    reloadConnectedIntegrations();
  }, []);

  const filteredIntegrations = connectedIntegrations.filter((integration) =>
    `${integration.name} ${integration.category}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <Container size="xl" py="xl">
      <Stack>
        <Group justify="space-between" align="center">
          <Title order={2}>Integrations</Title>
          <Button variant="filled" color="blue" onClick={handleOpenModal}>
            Add New Connection
          </Button>
        </Group>
        <Group justify="space-between" align="center">
          <Text c="dimmed">
            Manage and configure integrations with third-party services.
          </Text>
          {connectedIntegrations.length > 0 && (
            <TextInput
              placeholder="Search integrations..."
              value={search}
              onChange={(event) => setSearch(event.currentTarget.value)}
              leftSection={<IconSearch size={16} />}
              w={300}
            />
          )}
        </Group>

        {connectedIntegrations.length === 0 && (
          <Stack align="center" justify="center" style={{ height: "50vh" }}>
            <IconPlugOff size={48} color="gray" />
            <Text ta="center" c="dimmed">
              No integrations found. Click the "Add New Connection" button to
              start a new integration.
            </Text>
          </Stack>
        )}
        {filteredIntegrations.map((integration) => (
          <IntegrationCard integration={integration} />
        ))}
      </Stack>

      <AddIntegrationModal opened={isModalOpen} onClose={handleCloseModal} />
    </Container>
  );
};

export default Integration;
